"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var __1 = require("..");
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var react_merge_refs_1 = __importDefault(require("react-merge-refs"));
util_localization_1.default.addTranslations('de', {
    'clear search': 'Suche löschen',
    'advanced search': 'Erweiterte Suche',
});
var SimpleSearch = react_1.forwardRef(function SimpleSearch(_a, ref) {
    var searchFieldProps = _a.searchFieldProps, searchFieldClass = _a.searchFieldClass, color = _a.color, advancedSearch = _a.advancedSearch, onAdvancedSearchClose = _a.onAdvancedSearchClose, onAdvancedSearchOpen = _a.onAdvancedSearchOpen, advancedSearchIcon = _a.advancedSearchIcon, advancedSearchOpen = _a.advancedSearchOpen, advancedSearchOpenOnChange = _a.advancedSearchOpenOnChange;
    var _b = searchFieldProps || {}, onFocus = _b.onFocus, searchRef = _b.ref, searchRest = __rest(_b, ["onFocus", "ref"]);
    var _c = react_1.useState(false), advancedSearchVisible = _c[0], setAdvancedSearchVisible = _c[1];
    var advancedRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (advancedSearchVisible && Boolean(advancedSearch)) {
            onAdvancedSearchOpen === null || onAdvancedSearchOpen === void 0 ? void 0 : onAdvancedSearchOpen();
        }
        else {
            onAdvancedSearchClose === null || onAdvancedSearchClose === void 0 ? void 0 : onAdvancedSearchClose();
        }
    }, [advancedSearchVisible, advancedSearch]);
    return (jsx_runtime_1.jsxs("div", __assign({ ref: react_merge_refs_1.default([advancedRef, ref]) }, { children: [jsx_runtime_1.jsx(__1.SearchField, __assign({}, searchRest, { color: color, forceFocusStyle: advancedSearchVisible, className: searchFieldClass, onFocus: function (event) {
                    var caller = advancedSearchOpenOnChange !== null && advancedSearchOpenOnChange !== void 0 ? advancedSearchOpenOnChange : setAdvancedSearchVisible;
                    caller(false);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                }, action: Boolean(advancedSearch) && (jsx_runtime_1.jsx(__1.Tooltip, __assign({ title: util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["advanced search"], ["advanced search"]))), enterDelay: 2000 }, { children: jsx_runtime_1.jsx(__1.IconButton, __assign({ onClick: function () {
                            var caller = advancedSearchOpenOnChange !== null && advancedSearchOpenOnChange !== void 0 ? advancedSearchOpenOnChange : setAdvancedSearchVisible;
                            caller(true);
                        }, size: "small" }, { children: advancedSearchIcon !== undefined ? advancedSearchIcon : jsx_runtime_1.jsx(__1.Icon.MoreHoriz, {}, void 0) }), void 0) }), void 0)), ref: searchRef }), void 0),
            (advancedSearchOpen !== null && advancedSearchOpen !== void 0 ? advancedSearchOpen : advancedSearchVisible) && Boolean(advancedSearch) && (jsx_runtime_1.jsx(__1.Popover, __assign({ open: advancedSearchOpen !== null && advancedSearchOpen !== void 0 ? advancedSearchOpen : advancedSearchVisible, onClose: function () {
                    var caller = advancedSearchOpenOnChange !== null && advancedSearchOpenOnChange !== void 0 ? advancedSearchOpenOnChange : setAdvancedSearchVisible;
                    caller(false);
                }, anchorEl: advancedRef.current, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' } }, { children: jsx_runtime_1.jsx(__1.Paper, __assign({ elevation: 5, withPadding: true }, { children: advancedSearch }), void 0) }), void 0))] }), void 0));
});
exports.default = SimpleSearch;
var templateObject_1;
//# sourceMappingURL=SimpleSearch.js.map